import React, { useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import ContentLayout from "../../../../partials/content/ContentLayout";
import BalanceSheet from "./balanceSheet";
import ProfitLossStatement from "./profitLossStatement";
import CashFlowStatement from "./cashFlowStatement";
import OperationCashFlow from "./OperationCashFlow";
import AccountsReceivableAging from "./accountsReceivableAging";
import AccountsPayableAging from "./accountsPayableAging";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import FinanceDashboard from "./FinanceDashboard";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import GlAccountBalance from "./GlAccountBalance";
import SalesTax from "./salesTax";
function FinanceReport({ history }) {
  const { reload } = useGlobalData();
  useEffect(() => {}, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title="Finance Reports"
        breadcrumbs={[
          { page: "/reports", title: "Reports", active: false },
          {
            page: "/finance/finance-reports",
            title: "Finance Reports",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/reports");
            },
          },
        ]}
      />
      <ContentLayout>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="tabview">
              <div className="card">
                <TabView
                  renderActiveOnly={false}
                  className="tabview"
                  scrollable
                >
                  <TabPanel
                    header="Finance Dashboard"
                    rightIcon="fas fa-chart-area"
                  >
                    <FinanceDashboard />
                  </TabPanel>
                  <TabPanel
                    header="Balance Sheet"
                    rightIcon="fas fa-balance-scale"
                  >
                    <BalanceSheet />
                  </TabPanel>
                  <TabPanel header="Profit Loss" rightIcon="fas fa-chart-line">
                    <ProfitLossStatement />
                  </TabPanel>
                  <TabPanel
                    header="Cash Flow"
                    rightIcon="fas fa-money-bill-wave"
                  >
                    <CashFlowStatement />
                  </TabPanel>
                  <TabPanel
                    header="Operation Cash Flow"
                    rightIcon="fas fa-money-bill-wave"
                  >
                    <OperationCashFlow />
                  </TabPanel>
                  <TabPanel
                    header="A/R Aging"
                    rightIcon="fas fa-file-invoice-dollar"
                  >
                    <AccountsReceivableAging />
                  </TabPanel>
                  <TabPanel header="A/P Aging" rightIcon="fas fa-file-invoice">
                    <AccountsPayableAging />
                  </TabPanel>
                  <TabPanel header="Account Balance" rightIcon="fas fa-wallet">
                    <GlAccountBalance />
                  </TabPanel>
                  <TabPanel header="Sales Tax" rightIcon="fas fa-receipt">
                    <SalesTax />
                  </TabPanel>
                </TabView>
              </div>
            </div>
          </div>
        </div>
      </ContentLayout>
    </React.Fragment>
  );
}

export default FinanceReport;
